import { Carousel } from 'components/Carousel/Carousel'
import { ArtisticFilter } from 'common/Prose/nodeViews/Image/components/ImageVariant/ArtisticFilter'
import Styles from './ArtisticFilters.module.scss'
import { ArtisticFilterType } from '@cloudinary/url-gen/types/types'
import { CloudinaryImage } from '@cloudinary/url-gen'

interface Props {
  url: string
  onFilter: (image: CloudinaryImage, filter: ArtisticFilterType) => void
  selectedFilter?: ArtisticFilterType
}

export const filters: ArtisticFilterType[] = [
  'al_dente',
  'athena',
  'audrey',
  'aurora',
  'daguerre',
  'eucalyptus',
  'fes',
  'frost',
  'hairspray',
  'hokusai',
  'incognito',
  'linen',
  'peacock',
  'primavera',
  'quartz',
  'red_rock',
  'refresh',
  'sizzle',
  'sonnet',
  'ukulele',
  'zorro',
]

export const ArtisticFilters = ({ url, onFilter, selectedFilter }: Props) => {
  return (
    <div className={Styles.carouselContainer}>
      <Carousel withControls={false} options={{ skipSnaps: true, dragFree: true }}>
        {filters.map((filter) => (
          <ArtisticFilter
            key={filter}
            url={url}
            filter={filter}
            onPress={onFilter}
            isSelected={selectedFilter === filter}
          />
        ))}
      </Carousel>
    </div>
  )
}
